var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.273 4.94L9.333 4 5.333 8 9.333 12 10.273 11.06 7.22 8z",
    transform: "matrix(0 1 1 0 -.197 .197)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpward);
export default __webpack_public_path__ + "static/media/arrow-upward.4e9bc8feab74859d4a0bf68b87287806.svg";
export { ForwardRef as ReactComponent };